import EventConsultActionBarModal from 'components/modal/EventConsultActionBarModal'
import { KEYCLOAK_STORAGE_ACCESS_TOKEN } from 'constants/keycloakConstants'
import React, { useEffect } from 'react'
import FontAwesome from 'react-fontawesome'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { downloadExport } from 'services/exportService'
import { io } from 'socket.io-client'
import I18n from '../../resources/i18n/I18n'

const ActionBar = ({ actions = {}, addEvent, markAsRead, eventsToExport = [], toggleFilters, filters = {}, tooMuchEvents, resultsCount = 0 }) => {
  const [showModal, setShowModal] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const history = useHistory()
  const [exportAll, setExportAll] = React.useState(false)
  const [exportType, setExportType] = React.useState(eventsToExport.length ? 'pdf' : 'csv')
  const [exportId, setExportId] = React.useState(null)
  const [exportPourcentage, setExportPourcentage] = React.useState(0)
  const socketRef = React.useRef(null)

  const handleExportFinish = async () => {
    await downloadExport(exportId)
    setExportPourcentage(0)
    setExportId(null)
    toggleExportModal()
  }

  useEffect(() => {
    if (!actions.export || socketRef.current) {
      return
    }

    socketRef.current = io(undefined, {
      reconnection: true,
      auth: {
        token: `Bearer ${localStorage.getItem(KEYCLOAK_STORAGE_ACCESS_TOKEN)}`,
      },
      transports: ['websocket'],
    })

    socketRef.current.on('ExportProgressUpdate', async (progress) => {
      setExportPourcentage(progress)
    })

    socketRef.current.on('ExportError', () => {
      toast.error(I18n.t('ErrorExport'))
      setLoading(false)
      setExportId(null)
      setExportAll(false)
      setShowModal(false)
      setExportPourcentage(0)
    })

    return () => {
      socketRef.current.disconnect()
    }
  }, [])

  useEffect(() => {
    if (exportPourcentage === 100) {
      handleExportFinish()
    }
  }, [exportPourcentage])

  const toggleExportModal = () => {
    setShowModal(!showModal)
  }

  return (
    <div>
      <div className="d-flex gap-x-2">
        {markAsRead ? (
          <div className="d-flex flex-column justify-content-end">
            <a href="#0" className={`link ${eventsToExport.length === 0 && 'disabled'}`} onClick={markAsRead}>
              {I18n.t('MarkAsRead')}
            </a>
          </div>
        ) : null}
        <div className="action-button small d-md-none d-block" onClick={() => toggleFilters(true)}>
          <FontAwesome name="sliders" />
          <span className="icon-excel" />
        </div>
        {actions.export && (
          <div className={`action-button small ${resultsCount ? '' : 'disabled'}`} onClick={!resultsCount ? null : toggleExportModal}>
            <FontAwesome name="upload black" />
          </div>
        )}

        {addEvent ? (
          <div className="action-button small" onClick={() => history.push('/signalement', { from: location.pathname })}>
            <FontAwesome name="plus" />
          </div>
        ) : null}
      </div>
      <EventConsultActionBarModal
        showModal={showModal}
        tooMuchEvents={tooMuchEvents}
        eventsToExport={eventsToExport}
        filters={filters}
        exportType={exportType}
        exportAll={exportAll}
        loading={loading}
        exportPourcentage={exportPourcentage}
        exportId={exportId}
        setExportAll={setExportAll}
        setExportType={setExportType}
        toggleExportModal={toggleExportModal}
        setExportPourcentage={setExportPourcentage}
        setExportId={setExportId}
        setLoading={setLoading}
        socketRef={socketRef}
      />
    </div>
  )
}

export default ActionBar
